import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { microsoftAuthenticate } from "../../redux/actions/auth";
import queryString from "query-string";

const Microsoft = ({ microsoftAuthenticate, isAuthenticated }) => {
  const location = useLocation();
  const [redirect, setRedirect] = useState(false);
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    // Inicia la animación de opacidad
    setShowLoader(true);

    const values = queryString.parse(location.search);
    const state = values.state || null;
    const code = values.code || null;

    if (state && code) {
      microsoftAuthenticate(state, code).then(() => {
        setRedirect(true);
      });
    }
  }, [location, microsoftAuthenticate]);

  if (isAuthenticated || redirect) {
    return <Navigate to="/" />;
  }

  return (
    <div
      className={`
        flex justify-center items-center min-h-screen bg-gray-100 
        transition-opacity duration-700 
        ${showLoader ? "opacity-100" : "opacity-0"}
      `}
    >
      <div className="flex flex-col items-center">
        {/* Spinner */}
        <div className="relative w-16 h-16 animate-spin rounded-full border-t-4 border-blue-600 border-b-4 border-transparent"></div>
        <p className="mt-4 text-gray-700 text-lg font-medium">
          Authenticating with Microsoft...
        </p>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
});

export default connect(mapStateToProps, { microsoftAuthenticate })(Microsoft);
